import ContractsCargoTaxiListRequest, {
  ContractsCargoTaxiListOrderRequest,
} from "../../../../api/raily/contracts/cargo-taxi/list/contracts-cargo-taxi-list-request";
import paginationService from "../../../../utils/pagination/pagination.service";
import ContractsCargoTaxiListParams, {
  ContractsCargoTaxiListParamsOrder,
} from "./contracts-cargo-taxi-list-params";

const createOrder = (
  order: ContractsCargoTaxiListParamsOrder | undefined,
): ContractsCargoTaxiListOrderRequest | undefined => {
  switch (order) {
    case ContractsCargoTaxiListParamsOrder.DISTANCE_RATE_ASC:
      return ContractsCargoTaxiListOrderRequest.DISTANCE_RATE_ASC;
    case ContractsCargoTaxiListParamsOrder.DISTANCE_RATE_DESC:
      return ContractsCargoTaxiListOrderRequest.DISTANCE_RATE_DESC;
    case ContractsCargoTaxiListParamsOrder.VALID_SINCE_ASC:
      return ContractsCargoTaxiListOrderRequest.VALID_SINCE_ASC;
    case ContractsCargoTaxiListParamsOrder.VALID_SINCE_DESC:
      return ContractsCargoTaxiListOrderRequest.VALID_SINCE_DESC;
    case ContractsCargoTaxiListParamsOrder.VALID_TO_ASC:
      return ContractsCargoTaxiListOrderRequest.VALID_TO_ASC;
    case ContractsCargoTaxiListParamsOrder.VALID_TO_DESC:
      return ContractsCargoTaxiListOrderRequest.VALID_TO_DESC;
    default:
      return undefined;
  }
};

const create = (
  params: ContractsCargoTaxiListParams,
): ContractsCargoTaxiListRequest => {
  return {
    active: params.active,
    cargoCompanyName: params.cargoCompanyName,
    limit: params.pageSize,
    offset: paginationService.calculateOffset(params.page, params.pageSize),
    order: createOrder(params.order),
    taxiCorporationName: params.taxiCorporationName,
  };
};

const contractsCargoTaxiListParamsFactory = { create };

export default contractsCargoTaxiListParamsFactory;
